export const en = {
    any: 'Any number of transfers',
};
